import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, photoUrl } from "../lib/api";
import { useLang } from "../lib/i18n";
import { distLabel, catLabel } from "../lib/labels";
import AltaiMap from "../components/AltaiMap";
import Seo from "../components/Seo";

export default function MapPage() {
  const { t, lang } = useLang();
  const [features, setFeatures] = useState([]);
  const [sel, setSel] = useState(null);

  useEffect(() => {
    api.get("/geojson").then((r) => setFeatures(r.data.features || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="map-page" className="pt-[72px]" style={{ background: "#11110F", minHeight: "100vh" }}>
      <Seo path="/map" lang={lang} title={lang === "ru" ? "Карта Алтая" : "Map of Altai"} description={lang === "ru" ? "Интерактивная карта Алтая: все точки маршрутов АРГАЛИ и связанные экскурсии." : "Interactive map of Altai: all АРГАЛИ route points and related excursions."} />
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-[68%] w-full">
          <AltaiMap features={features} height="calc(100vh - 72px)" onSelectPlace={setSel} activeId={sel?.id} />
        </div>
        <aside className="lg:w-[32%] w-full grain" style={{ background: "#11110F", minHeight: "40vh" }}>
          <div className="p-8 md:p-10 sticky top-[72px]">
            {!sel ? (
              <div>
                <p className="eyebrow">{lang === "ru" ? "Карта" : "Map"}</p>
                <h1 className="display display-md text-argali-ivory mt-3">{lang === "ru" ? "Весь Алтай." : "All of Altai."}</h1>
                <p className="text-argali-ivory/70 mt-5 text-sm leading-relaxed">
                  {lang === "ru" ? "Выберите точку на карте, чтобы увидеть место и связанные маршруты." : "Select a point on the map to see the place and its related routes."}
                </p>
                <p className="text-argali-sandstone/50 text-xs mt-6">{features.length} {lang === "ru" ? "точек" : "points"}</p>
              </div>
            ) : (
              <div data-testid="map-side-panel">
                <div className="relative aspect-[4/3] overflow-hidden mb-5">
                  <img src={photoUrl(sel.photo_id)} alt={sel.name_ru} className="w-full h-full object-cover" />
                </div>
                <h2 className="font-serif text-3xl text-argali-ivory">{lang === "ru" ? sel.name_ru : sel.name_en}</h2>
                <p className="text-argali-sandstone/60 text-sm">{lang === "ru" ? sel.name_en : sel.name_ru}</p>
                <p className="eyebrow mt-4">{distLabel(sel.district, lang)}</p>
                <p className="text-argali-ivory/60 text-xs uppercase tracking-widest mt-1">{catLabel(sel.category, lang)}</p>
                {sel.excursions && sel.excursions.length > 0 && (
                  <div className="mt-6">
                    <p className="text-[0.62rem] uppercase tracking-[0.16em] text-argali-brown/60 mb-3">{sel.excursions.length} {t("routes_count")}</p>
                    <div className="space-y-2">
                      {sel.excursions.map((ex) => (
                        <Link key={ex.id} to={`/excursions/${ex.slug}`} className="group flex items-center justify-between border border-argali-brown/30 px-4 py-3 hover:border-argali-bronze transition-colors">
                          <span className="text-argali-ivory text-sm">{lang === "ru" ? ex.title_ru : ex.title_en}</span>
                          <ArrowRight size={15} className="text-argali-gold btn-arrow" />
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </aside>
      </div>
    </div>
  );
}
